// const baseUrl = 'http://localhost:1102/';
const baseUrl = 'https://impactzoneapi.appdeft.in/';

const endPointUrl = baseUrl + 'api/user';

const constants = { baseUrl, endPointUrl };

export default constants;
